// import Calendar from '@toast-ui/calendar';
// import '@toast-ui/calendar/dist/toastui-calendar.min.css';
// import "tui-date-picker/dist/tui-date-picker.css";
// import "tui-time-picker/dist/tui-time-picker.css";
import Moment from "moment";
import Chance from "chance";

// global.Calendar = Calendar;
global.moment = Moment;
export default new Chance();
